module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iscroll-view', {
    ref: "scrollView",
    staticClass: "scroll-view msg-items",
    attrs: {
      "options": {
        click: true,
        scrollY: true,
        mouseWheel: true,
        probeType: 1
      },
      "scrollerClass": {
        'scroller': true
      }
    },
    on: {
      "scroll": _vm.scrolling,
      "scrollEnd": _vm.scrollEnd
    }
  }, [_vm._l((_vm.msgs), function(item) {
    return _c('div', [_c('div', {
      staticClass: "separation-area"
    }), _vm._v(" "), _c('div', {
      staticClass: "msg-item"
    }, [_c('router-link', {
      staticClass: "title",
      attrs: {
        "to": {
          path: 'msg-detail',
          query: {
            type: item.type_en_name,
            subType: item.sub_type_en_name
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "company-name",
      domProps: {
        "innerHTML": _vm._s(item.company)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "company-name"
    }, [_vm._v(_vm._s(_vm._f("enToCn")('beijing')) + "(使用自定义过滤器enToCn)")]), _vm._v(" "), _c('div', {
      staticClass: "company-name"
    }, [_vm._v(_vm._s(_vm._f("formatMoney")(30, 2, '$')) + "(使用自定义过滤器formatMoney)")]), _vm._v(" "), _c('div', {
      staticClass: "bottom-line"
    }, [_c('div', {
      staticClass: "type",
      domProps: {
        "innerHTML": _vm._s(item.type_cn_name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right-part"
    }, [_c('div', {
      staticClass: "collect-icon ",
      class: item.collected ? 'icon-has-collect' : 'icon-not-collect',
      on: {
        "click": function($event) {
          _vm.setCollect(item)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.push_time, 'YYYY-MM-DD')))])])])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "data-load-tips"
  }, [_vm._v(_vm._s(_vm.loadStatusConfig[_vm.loadStatus]))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92f20218"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/msg-cards.vue
// module id = 178
// module chunks = 1